<template>
  <v-dialog
    :model-value="activator"
    :width="mobile ? '100%' : '85%'"
    :content-class="
      mobile
        ? 'bg-background pwt-scrollbar-styles'
        : 'rounded-lg bg-background pwt-scrollbar-styles'
    "
    class="pwt-scroll-styles"
    scrollable
    style="z-index: 1200"
    @click:outside="emitClose()"
    @keydown="keyDown($event)"
    :fullscreen="mobile"
    :max-height="mobile ? undefined : '90vh'"
    :min-height="mobile ? undefined : '90vh'"
  >
    <!-- must have vh for height to work with v-dialog having no exposed height prop. -->
    <v-card
      style="height: 80vh"
      :class="mobile ? 'bg-background overflow-hidden' : 'rounded-lg bg-background overflow-hidden'"
      flat
    >
      <div
        id="dashboard-scroll-container"
        class="pwt-scroll-container pwt-scrollbar-styles overflow-y-auto"
      >
        <!-- second card to counteract miss-behaving v-dialog overflow due to vh needed earlier. -->
        <v-card
          class="pt-5 bg-background"
          :class="mobile ? 'px-0 pt-10' : 'pr-10 pl-5'"
          flat
          style="position: relative"
        >
          <DashboardMobileAppBar
            v-if="mobile"
            @close="emitClose"
            @view-account="viewAccount"
            @view-vehicle="viewVehicle"
            @view-vehicles="viewAllVehicles"
            @view-defaults="viewDefaults"
            @view-locations="viewLocationsManager"
            @view-saved-trips="viewSavedTrips"
            @view-sales-leads="viewSalesLeads"
            :tab="tab"
          />
          <!-- tabs -->
          <v-tabs
            v-if="!mobile"
            direction="vertical"
            :model-value="tab"
            style="position: fixed; top: 40px; width: 200px"
            hide-slider
            @update:model-value="resetScrollPosition"
            optional
            class="pr-5"
          >
            <v-tab
              class="text-none"
              :class="tab === 'account' ? 'bg-pwt_azure_20' : 'bg-background'"
              tab-value="account"
              @click="viewAccount"
            >
              Account <v-spacer></v-spacer>
            </v-tab>
            <v-tab
              class="text-none"
              :class="tab === 'vehicle-details' ? 'bg-pwt_azure_20' : 'bg-background'"
              tab-value="vehicle-details"
              @click="viewVehicle(undefined)"
            >
              Vehicle details <v-spacer></v-spacer>
            </v-tab>
            <v-tab
              class="text-none"
              :class="tab === 'fleet-vehicles' ? 'bg-pwt_azure_20' : 'bg-background'"
              tab-value="fleet-vehicles"
              @click="viewAllVehicles"
            >
              Available vehicles <v-spacer></v-spacer>
            </v-tab>
            <v-tab
              class="text-none"
              :class="tab === 'locations-manager' ? 'bg-pwt_azure_20' : 'bg-background'"
              tab-value="locations-manager"
              @click="viewLocationsManager"
            >
              Locations manager
              <v-spacer></v-spacer>
            </v-tab>
            <v-tab
              class="text-none"
              :class="tab === 'defaults' ? 'bg-pwt_azure_20' : 'bg-background'"
              tab-value="defaults"
              @click="viewDefaults"
            >
              Trip planning defaults
              <v-spacer></v-spacer>
            </v-tab>
            <v-tab
              class="text-none"
              :class="tab === 'saved-trips' ? 'bg-pwt_azure_20' : 'bg-background'"
              tab-value="saved-trips"
              @click="viewSavedTrips"
            >
              Saved trips <v-spacer></v-spacer>
            </v-tab>
            <v-tab
              v-if="canViewSales"
              class="text-none"
              :class="tab === 'sales-leads' ? 'bg-pwt_azure_20' : 'bg-background'"
              tab-value="sales-leads"
              @click="viewSalesLeads"
            >
              Sales leads <v-spacer></v-spacer>
            </v-tab>
          </v-tabs>
          <v-tabs-window
            v-model="tab"
            :style="
              mobile
                ? ''
                : 'margin-left: 200px; border-left: 2px solid rgba(218, 218, 218, 0.5) !important'
            "
            class="bg-background"
            :class="mobile ? 'pa-5' : 'py-5 pl-10 pr-5'"
          >
            <v-tabs-window-item value="account">
              <DashboardBreadcrumbs
                v-if="!mobile"
                :items="[{ text: 'Manage account', disabled: true }]"
                @navigation="breadcrumbNavigation"
                @back="breadcrumbNavigation({ text: 'Manage account' })"
              />
              <EditUserContent />
            </v-tabs-window-item>
            <v-tabs-window-item value="vehicle-details">
              <DashboardBreadcrumbs
                v-if="!mobile"
                :items="[
                  { text: 'Available vehicles' },
                  { text: 'Vehicle details', disabled: true },
                ]"
                @navigation="breadcrumbNavigation"
                @back="breadcrumbNavigation({ text: 'Available vehicles' })"
              />
              <VehicleDetails :vehicle="vehicleData" :isSelected="isSelected" />
            </v-tabs-window-item>
            <v-tabs-window-item value="fleet-vehicles">
              <DashboardBreadcrumbs
                v-if="!mobile"
                :items="[{ text: 'Available vehicles', disabled: true }]"
                @navigation="breadcrumbNavigation"
                @back="breadcrumbNavigation({ text: 'Manage account' })"
              />
              <VehicleList @view-vehicle="viewVehicle($event.localId)" />
            </v-tabs-window-item>
            <v-tabs-window-item value="locations-manager">
              <DashboardBreadcrumbs
                v-if="!mobile"
                :items="[{ text: 'Location manager', disabled: true }]"
                @navigation="breadcrumbNavigation"
                @back="breadcrumbNavigation({ text: 'Manage account' })"
              />
              <FavLocationsMain />
            </v-tabs-window-item>
            <v-tabs-window-item value="defaults">
              <DashboardBreadcrumbs
                v-if="!mobile"
                :items="[{ text: 'Edit trip planning presets', disabled: true }]"
                @navigation="breadcrumbNavigation"
                @back="breadcrumbNavigation({ text: 'Manage account' })"
              />
              <TripPlanningDefaults />
            </v-tabs-window-item>
            <v-tabs-window-item value="saved-trips">
              <SavedTripsContent @close="emitClose" />
            </v-tabs-window-item>
            <v-tabs-window-item v-if="canViewSales" value="sales-leads">
              <SalesLeadsMain />
            </v-tabs-window-item>
          </v-tabs-window>
        </v-card>
      </div>
      <!-- floating close button -->
      <v-btn
        v-if="!mobile"
        icon
        @click.stop="emitClose()"
        style="position: absolute; top: 8px; right: 12px"
        flat
        color="transparent"
      >
        <v-icon color="grey-lighten-1">mdi-close</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import Vehicle from '@/classes/vehicle_classes/vehicle'
import EditUserContent from '@/components/user/profile/EditUserContent.vue'
import { GettersTypes, MutationTypes, type State } from '@/store/store_types'
import { computed, nextTick, watch } from 'vue'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'
import FavLocationsMain from '../favourite-locations/FavLocationsMain.vue'
import SalesLeadsMain from '../sales-leads/SalesLeadsMain.vue'
import VehicleDetails from '../vehicles/VehicleDetails.vue'
import VehicleList from '../vehicles/VehicleList.vue'
import DashboardBreadcrumbs, { type BreadcrumbsItem } from './DashboardBreadcrumbs.vue'
import DashboardMobileAppBar from './DashboardMobileAppBar.vue'
import SavedTripsContent from './SavedTripsContent.vue'
import TripPlanningDefaults from './TripPlanningDefaults.vue'

const { activator } = defineProps<{ activator: boolean }>()
const emit = defineEmits<{
  (e: 'close'): void
}>()
const { mobile } = useDisplay()

// state
const store = useStore<State>()
const canViewSales = computed(() => {
  return store.state.permissions.hasAccessPermission('sales_leads', 'read')
})
const tab = computed(() => store.state.dashboardDialogContent)
const vehicleData = computed<Vehicle | undefined>(
  () => store.getters[GettersTypes.displayedVehicle],
)
const isSelected = computed<boolean>(
  () => vehicleData.value?.localId === store.state.selectedVehicle,
)

//  general methods
function emitClose() {
  emit('close')
}

function keyDown(event: KeyboardEvent) {
  if (event.key === 'Escape') emitClose()
}

function resetScrollPosition() {
  nextTick(() => {
    const myDiv = document.getElementById('dashboard-scroll-container')
    if (myDiv) myDiv.scrollTop = 0
  })
}

// navigation methods

function viewVehicle(id: string | undefined) {
  store.commit(MutationTypes.setViewedFleetVehicle, id)
  store.commit(MutationTypes.setDashboardDialogContent, 'vehicle-details')
  resetScrollPosition()
}

function viewAllVehicles() {
  store.commit(MutationTypes.setDashboardDialogContent, 'fleet-vehicles')
  resetScrollPosition()
}

function viewAccount() {
  store.commit(MutationTypes.setDashboardDialogContent, 'account')
  resetScrollPosition()
}

function viewLocationsManager() {
  store.commit(MutationTypes.setDashboardDialogContent, 'locations-manager')
  resetScrollPosition()
}

function viewDefaults() {
  store.commit(MutationTypes.setDashboardDialogContent, 'defaults')
  resetScrollPosition()
}

function viewSavedTrips() {
  store.commit(MutationTypes.setDashboardDialogContent, 'saved-trips')
  resetScrollPosition()
}

function viewSalesLeads() {
  store.commit(MutationTypes.setDashboardDialogContent, 'sales-leads')
  resetScrollPosition()
}

function breadcrumbNavigation(item: BreadcrumbsItem) {
  if (item.disabled) return
  if (item.text === 'Available vehicles') {
    viewAllVehicles()
  } else if (item.text === 'Edit trip planning presets') {
    viewDefaults()
  } else if (item.text === 'Manage account') {
    viewAccount()
  } else if (item.text === 'Location manager') {
    viewLocationsManager()
  } else if (item.text === 'Vehicle details') {
    viewVehicle(undefined)
  } else if (item.text === 'Saved trips') {
    viewSavedTrips()
  } else if (item.text === 'Sales leads') {
    viewSalesLeads()
  }
}

// watchers

watch(
  () => activator,
  () => {
    resetScrollPosition()
  },
)
</script>
<style scoped>
* :deep(.v-slide-group__prev) {
  flex: unset !important;
  min-width: 0px !important;
}

* :deep(.v-slide-group) {
  background-color: var(--v-background-base) !important;
}

.pwt-scroll-container {
  width: 100%;
  height: 100%;
}

.pwt-scrollbar-styles {
  scrollbar-color: #ffffff #e0e0e0;
  scrollbar-width: thin;
}

.pwt-scrollbar-styles:hover {
  scrollbar-color: #eeeeee #e0e0e0;
}

.pwt-scrollbar-styles::-webkit-scrollbar {
  width: 6px;
}

.pwt-scrollbar-styles::-webkit-scrollbar-track {
  background: #ffffff;
}

.pwt-scrollbar-styles::-webkit-scrollbar-track:hover {
  background: #e0e0e0;
}

.pwt-scrollbar-styles::-webkit-scrollbar-thumb {
  background: #ffffff;
}

.pwt-scrollbar-styles::-webkit-scrollbar-thumb:hover {
  background: #eeeeee;
}
</style>
